import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useEffect } from 'react';
import { ExperienceTracker } from '@atlassian/experience-tracker';
import { isClientFetchError } from '../../common/utils/is-error';
import { logException } from '../../services/sentry';
import { useAnalytics } from '../analytics';

// Re-exporting some experience trackers packages
export { ExperienceTracker, ExperienceTrackerContext } from '@atlassian/experience-tracker';
var ExperienceTrackerHandler = /*#__PURE__*/function () {
  function ExperienceTrackerHandler() {
    var _this = this;
    _classCallCheck(this, ExperienceTrackerHandler);
    _defineProperty(this, "experienceTracker", new ExperienceTracker());
    _defineProperty(this, "sendAnalyticsEvent", null);
    this.experienceTracker.subscribe(function (event) {
      var _this$sendAnalyticsEv;
      // for FailEvent
      if ('error' in event) {
        var _event$error;
        // do not fail experience tracking if the error is a client fetch error
        if (isClientFetchError(event.error)) {
          return;
        }
        var errorMetadata = (_event$error = event.error) === null || _event$error === void 0 ? void 0 : _event$error.metadata;

        // Filter 5xx errors since backend monitoring will cover this
        // as per https://hello.atlassian.net/wiki/spaces/CONVAI/pages/3547354267/Meeting+notes+FE+SLOs+which+one+to+promote
        if ((errorMetadata === null || errorMetadata === void 0 ? void 0 : errorMetadata.statusCode) >= 500) {
          return;
        }
        var error = event.error instanceof Error ? event.error : new Error(JSON.stringify(event.error));
        logException({
          exception: error,
          name: event.name,
          tags: {
            source: 'aiMateExperienceTracker',
            apiErrorMessage: errorMetadata === null || errorMetadata === void 0 ? void 0 : errorMetadata.rawErrorMessage,
            apiErrorCode: errorMetadata === null || errorMetadata === void 0 ? void 0 : errorMetadata.errorCode
          }
        });
      }
      (_this$sendAnalyticsEv = _this.sendAnalyticsEvent) === null || _this$sendAnalyticsEv === void 0 || _this$sendAnalyticsEv.call(_this, {
        eventType: 'operational',
        action: event.action,
        actionSubject: 'ui',
        attributes: _objectSpread({
          task: event.name,
          taskId: event.id,
          startTime: event.startTime
        }, event.attributes)
      }, {
        removeDefaultTags: true
      });
    });
  }
  _createClass(ExperienceTrackerHandler, [{
    key: "setSendAnalyticsEvent",
    value: function setSendAnalyticsEvent(sendAnalyticsEvent) {
      this.sendAnalyticsEvent = sendAnalyticsEvent;
    }
  }], [{
    key: "getInstance",
    value: function getInstance() {
      if (!ExperienceTrackerHandler.instance) {
        ExperienceTrackerHandler.instance = new ExperienceTrackerHandler();
      }
      return ExperienceTrackerHandler.instance;
    }
  }]);
  return ExperienceTrackerHandler;
}();
export var useAIMateExperienceTracker = function useAIMateExperienceTracker() {
  var _useAnalytics = useAnalytics(),
    sendAnalyticsEvent = _useAnalytics.sendAnalyticsEvent;
  useEffect(function () {
    ExperienceTrackerHandler.getInstance().setSendAnalyticsEvent(sendAnalyticsEvent);
  }, [sendAnalyticsEvent]);
  return ExperienceTrackerHandler.getInstance().experienceTracker;
};